"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyCaptured = exports.StudyCapture = exports.StudyCaptureData = exports.StudyCaptureDataStatus = exports.StudyCaptureDataVal = exports.StudyCaptureDataItemId = exports.StudyCaptureDataPageId = void 0;
class StudyCaptureDataPageId {
}
exports.StudyCaptureDataPageId = StudyCaptureDataPageId;
class StudyCaptureDataItemId extends StudyCaptureDataPageId {
}
exports.StudyCaptureDataItemId = StudyCaptureDataItemId;
class StudyCaptureDataVal {
}
exports.StudyCaptureDataVal = StudyCaptureDataVal;
class StudyCaptureDataStatus {
}
exports.StudyCaptureDataStatus = StudyCaptureDataStatus;
class StudyCaptureData {
}
exports.StudyCaptureData = StudyCaptureData;
class StudyCapture {
}
exports.StudyCapture = StudyCapture;
class StudyCaptured {
}
exports.StudyCaptured = StudyCaptured;
//# sourceMappingURL=studyCapture.js.map